<div class="registration-form" [formGroup]="joinFlowForm" [ngSwitch]="step">
  <ng-container *ngSwitchCase="0" formGroupName="firstStep">
    <form [formGroup]="firstAccessor" autocomplete="off">
      <div class="form__panel-first active">
        <h1 class="banner-size">Start your learning journey now.</h1>
        <p>By joining AmiLearn, you gain instant access to a wealth of free content so you can embark on your learning journey into Digital Assets right away.</p>
        <fieldset>
          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput autocomplete="off" [formControl]="firstAccessor.controls[FormControlName.firstName]" required>
              <mat-error class="push-right">Please enter your First Name</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput autocomplete="off" [formControl]="firstAccessor.controls[FormControlName.lastName]" required>
              <mat-error>Please enter your Last Name</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input matInput autocomplete="off" [formControl]="firstAccessor.controls[FormControlName.email]" required>
              <mat-error>Please enter a valid email address</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>Choose a password</mat-label>
              <input matInput autocomplete="off" [type]="'password'" [formControl]="firstAccessor.controls[FormControlName.password]" required>
              <mat-error>Please enter a password</mat-error>
            </mat-form-field>
          </div>
          <p class="password-info">
            minimum 8 characters, maximum 64, requires one upper case, lower case, symbol and numeric character.
          </p>
        </fieldset>
        <div class="button-box--flex">
          <button
                  type="submit"
                  mat-raised-button
                  color="primary"
                  (click)="submitFirstStep()">
                  JOIN AMILEARN
          </button>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngSwitchCase="1" formGroupName="secondStep">
    <form [formGroup]="secondAccessor">
      <div class="form__panel-second">
        <h2 class="banner-size">Account Information</h2>
        <fieldset>
              <div class="input-field grid-half-left">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
                  <input matInput autocomplete="off" [formControl]="secondAccessor.controls[FormControlName.city]" required>
                  <mat-error>Please enter a city</mat-error>
                </mat-form-field>
              </div>
              <div class="input-field grid-half-right">
                <mat-form-field appearance="outline">
                  <mat-label>Province / State</mat-label>
                  <mat-select [formControl]="secondAccessor.controls[FormControlName.province]" required (selectionChange)="onProvinceSelect($event, country.value)">
                    <ng-container *ngIf="['US', 'CA'].includes(country.value); then usaOrCanada; else mergedList"></ng-container>
                    <ng-template #usaOrCanada>
                      <mat-option *ngFor="let state of jurisdictions[country.value]" [value]="state[1]">
                        {{state[0]}}
                      </mat-option>
                    </ng-template>
                    <ng-template #mergedList>
                      <mat-optgroup *ngFor="let group of jurisdictions[countryCode.MERGED]" [label]="group.viewValue">
                        <mat-option *ngFor="let land of group.value" [value]="land[1]">
                          {{land[0]}}
                        </mat-option>
                      </mat-optgroup>
                    </ng-template>
                  </mat-select>
                  <mat-error>Please enter a Province / State</mat-error>
                </mat-form-field>
              </div>


          <div class="input-field grid-half-left">
            <mat-form-field appearance="outline">
              <mat-label>Country</mat-label>
              <mat-select [formControl]="secondAccessor.controls[FormControlName.country]" #country required>
                <mat-option *ngFor="let country of countries" [value]="country.value">
                  {{country.viewValue}}
                </mat-option>
              </mat-select>
              <mat-error>Please enter a Country</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-half-right">
            <mat-form-field appearance="outline">
              <mat-label>Postal / Zip Code</mat-label>
              <input matInput autocomplete="off" [formControl]="secondAccessor.controls[FormControlName.zipCode]" required>
              <mat-error>Please enter a Postal / Zip code</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>Organization / Employer</mat-label>
              <input matInput autocomplete="off" [formControl]="secondAccessor.controls[FormControlName.employer]" required>
              <mat-error>Please enter a Organization name</mat-error>
            </mat-form-field>
          </div>

          <div class="input-field grid-form-full">
            <mat-form-field appearance="outline">
              <mat-label>Position / Job Title</mat-label>
              <input matInput autocomplete="off" [formControl]="secondAccessor.controls[FormControlName.jobTitle]" required>
              <mat-error>Please enter a job title</mat-error>
            </mat-form-field>
          </div>
        </fieldset>

        <div class="button-box--flex">
          <button
                  type="button"
                  mat-flat-button
                  class="btn btn-secondary"
                  (click)="goBack()">
                  Back
          </button>

          <button
                  type="submit"
                  mat-raised-button
                  color="primary"
                  (click)="submitSecondStep()">
                  Next
          </button>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngSwitchCase="2" formGroupName="thirdStep">
    <form [formGroup]="thirdAccessor">
      <div class="form__panel-third">
        <h2 class="banner-size">Terms & Conditions</h2>

        <fieldset>
          <div class="grid-form-full">
            <div class="form__t-and-c">
              <div class="form__t-and-c-content-box">
                <app-terms-and-conditions-content />
              </div>
            </div>

            <div class="form__t-and-c--accept">
              <mat-checkbox [formControl]="thirdAccessor.controls[FormControlName.termsAndConditions]">
                I have read and acknowledge the terms and conditions as outlined above.
              </mat-checkbox>
            </div>
            <mat-error *ngIf="showErrorTextTermsAndConditions()" class="form__t-and-c--error">Please accept the Terms and Conditions</mat-error>
          </div>
        </fieldset>
        <div class="button-box--flex">
          <button
                  type="button"
                  mat-flat-button
                  (click)="goBack()">
                  Back
          </button>
          <button
                  type="submit"
                  mat-raised-button
                  color="primary"
                  [disabled]="thirdAccessor.invalid"
                  (click)="submitThirdStep()">
                  Register
          </button>
        </div>
      </div>
    </form>
</ng-container>
  <ng-container *ngSwitchCase="3">
    <div class="form__panel-fourth">
      <h2 class="banner-size">
        Welcome to AmiLearn
      </h2>
      <div class="progress-container">
        <mat-spinner diameter="65"></mat-spinner>
        <p>Please wait while we complete your registration</p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="4">
    <div class="form__panel-fifth">
      <h2 class="banner-size">
        Welcome to AmiLearn
      </h2>

    <div class="finish-container">
      <p>You have been successfully registered.</p>
      <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="afterRegisteringClick()">
              Ok
      </button>
    </div>
  </div>
  </ng-container>
  <ng-container *ngSwitchCase="5">
    <div class="form__panel-sixth">
      <h2 class="banner-size">
        Form Submission Error
      </h2>

      <div class="finish-container">

        <ng-container *ngIf="errorState === BackEndErrorState.FIELDS_VALIDATION_FAILED">
          <p>Please ensure all required fields are completed prior to submission.</p>
        </ng-container>

        <ng-container *ngIf="errorState === BackEndErrorState.USER_ALREADY_REGISTERED">
          <p>This email address is already registered on AmiLearn.</p>
        </ng-container>

        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="onErrorCTA()">
          <ng-container *ngIf="errorState === BackEndErrorState.FIELDS_VALIDATION_FAILED">
            Back to form
          </ng-container>
          <ng-container *ngIf="errorState === BackEndErrorState.USER_ALREADY_REGISTERED">
            Log in
          </ng-container>
        </button>

        <p>If you continue to experience problems, please contact
          <a href="{{supportEmailHref}}">support@meetami.ca</a>.
        </p>

        <p *ngIf="publicErrorCode">Error code: {{publicErrorCode}}</p>
        
      </div>
    </div>
  </ng-container>
</div>
